module.exports = __webpack_public_path__ + "img/DPD_logo_redgrad_rgb.1feb8460.png";